import {
  apiProtocol,
  apiHost,
  apiPort,
  isDevelopment
} from '../../config/config';

const shouldAlterHost = isDevelopment;

export function host() {
  const port =
    shouldAlterHost && apiPort.length && apiPort !== '443' && apiPort !== '80'
      ? `:${apiPort}`
      : '';
  return shouldAlterHost ? `${apiProtocol}://${apiHost}${port}` : '';
}

export default host;
